import { atom } from 'recoil';

export const listFiltersAtom = atom({
    key: 'listFiltersAtom', 
    default: {},
});